<div class="p-4">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
  <div class="loader-overlay" *ngIf="isLoading">
    <p-progress-spinner ariaLabel="loading" />
  </div>

  <div class="card">
    <form
      *ngIf="claimContractForm"
      [formGroup]="claimContractForm"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="off"
    >
      <div class="card bg-white border-round">
        <div class="card-header p-3 ml-auto border-bottom-1 border-gray-200">
          <div class="flex align-items-center justify-content-between gap-3 flex-wrap">
            <h2 class="m-0">Claim Contract</h2>
            <div class="flex gap-2 align-items-center flex-wrap">
              <input
                #claimContractExcelInput
                type="file"
                class="hidden"
                [accept]="claimImportAcceptTypes"
                (change)="onClaimContractExcelSelect($event)"
              />
              <p-inputgroup styleClass="w-25rem">
                <input
                  pInputText
                  type="text"
                  [value]="selectedImportFileName || 'Choose Excel file'"
                  readonly
                />
                <button
                  pButton
                  type="button"
                  label="Browse"
                  icon="pi pi-upload"
                  class="p-button-outlined"
                  (click)="claimContractExcelInput.click()"
                ></button>
              </p-inputgroup>
              <button
                pButton
                type="button"
                label="Download Template"
                icon="pi pi-download"
                class="p-button-secondary p-button-outlined"
                (click)="downloadClaimContractTemplate()"
              ></button>
            </div>
          </div>
        </div>
        <div class="card-body p-3 mt-3">
          <div class="mr-5 flex align-items-center mb-3">
            <i class="pi pi-file-edit mr-2 text-3xl"></i>
            <div class="font-medium text-3xl text-900">
              Claim Contract Details
            </div>
          </div>

          <div
            class="grid formgrid p-fluid p-3"
            formArrayName="claimContractDetails"
          >
            <div
              *ngFor="
                let detail of claimContractDetails.controls;
                let i = index
              "
              [formGroupName]="i"
              class="grid formgrid p-fluid"
            >
              <!-- select business -->
              <div class="col-12 md:col-3">
                <p-inputgroup>
                  <p-inputgroup-addon
                    ><i class="pi pi-users"></i
                  ></p-inputgroup-addon>
                  <p-iftalabel>
                    <p-dropdown
                      [filter]="true"
                      [fluid]="true"
                      [options]="filteredBusinesses"
                      formControlName="business"
                      inputId="business"
                      optionLabel="businessName"
                      styleClass="w-full"
                      placeholder="Select Business"
                      [ngClass]="{
                        'p-invalid': isDetailsInvalid(i, 'business')
                      }"
                      (onChange)="onBusinessChange(i, $event.value)"
                      [panelStyle]="{ width: '70%' }"
                    >
                      <ng-template let-business pTemplate="selectedItem">
                        <div *ngIf="business">
                          {{ business.businessCode }} -
                          {{ business.businessName }}
                        </div>
                      </ng-template>
                      <ng-template let-business pTemplate="item">
                        <div>
                          {{ business.businessCode }} -
                          {{ business.businessName }}
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-business>
                        <p-inputgroup>
                          <p-inputgroup-addon>
                            <i class="pi pi-search"></i>
                          </p-inputgroup-addon>
                          <input
                            #businessInput
                            type="text"
                            pInputText
                            placeholder="Filter"
                            (keyup)="filterBusinesses($event, i)"
                            value="{{ BusinessfilterValue[i] }}"
                          />
                          <!-- <p-button
                            type="button"
                            icon="pi pi-times"
                            (click)="business.reset(); businessInput.value = ''"
                            styleClass="p-button-secondary"
                          ></p-button> -->
                        </p-inputgroup>
                      </ng-template>
                    </p-dropdown>
                    <label for="customer"
                      >Business<span class="requiredLable">*</span></label
                    >
                  </p-iftalabel>
                </p-inputgroup>
              </div>

              <!-- selected Business suppliers -->
              <div class="field col-12 md:col-3">
                <p-inputgroup>
                  <p-inputgroup-addon>
                    <i class="pi pi-building"></i>
                  </p-inputgroup-addon>
                  <p-iftalabel>
                    <p-dropdown
                      [filter]="true"
                      [fluid]="true"
                      [options]="suppliersPerRow[i]"
                      formControlName="supplier"
                      optionLabel="supplierName"
                      inputId="supplier"
                      class="w-full"
                      placeholder="Select Supplier"
                      [ngClass]="{
                        'p-invalid': isDetailsInvalid(i, 'supplier')
                      }"
                      [panelStyle]="{ width: '70%' }"
                    >
                      <ng-template let-supplier pTemplate="selectedItem">
                        <div *ngIf="supplier">
                          {{ supplier.supplierNumber }} -
                          {{ supplier.supplierName }}
                        </div>
                      </ng-template>

                      <ng-template let-supplier pTemplate="item">
                        <div>
                          {{ supplier.supplierNumber }} -
                          {{ supplier.supplierName }}
                        </div>
                      </ng-template>

                      <ng-template pTemplate="filter" let-supplier>
                        <p-inputgroup>
                          <p-inputgroup-addon>
                            <i class="pi pi-search"></i>
                          </p-inputgroup-addon>
                          <input
                            #supplierInput
                            type="text"
                            pInputText
                            placeholder="Filter"
                            (keyup)="filterSuppliers($event, i)"
                            value="{{ SupplierfilterValue[i] }}"
                          />
                          <!-- <p-button
                            type="button"
                            icon="pi pi-times"
                            (click)="supplier.reset(); supplierInput.value = ''"
                            styleClass="p-button-secondary"
                          ></p-button> -->
                        </p-inputgroup>
                      </ng-template>
                    </p-dropdown>
                    <label for="supplier"
                      >Supplier<span class="requiredLable">*</span></label
                    >
                  </p-iftalabel>
                </p-inputgroup>
              </div>

              <!-- selected Activity Type -->
              <div class="field col-12 md:col-3">
                <p-inputgroup>
                  <p-inputgroup-addon>
                    <i class="pi pi-building"></i>
                  </p-inputgroup-addon>
                  <p-iftalabel>
                    <p-dropdown
                      [filter]="true"
                      [fluid]="true"
                      [options]="filteredActivityTypes"
                      formControlName="activityType"
                      optionLabel="activityTypeName"
                      inputId="activityType"
                      class="w-full"
                      placeholder="Select Activity Type"
                      [panelStyle]="{ width: '70%' }"
                      [ngClass]="{
                        'p-invalid': isDetailsInvalid(i, 'activityType')
                      }"
                    >
                      <ng-template let-activityType pTemplate="selectedItem">
                        <div *ngIf="activityType">
                          {{ activityType.name }}
                        </div>
                      </ng-template>

                      <ng-template let-activityType pTemplate="item">
                        <div>
                          {{ activityType.name }}
                        </div>
                      </ng-template>

                      <ng-template pTemplate="filter" let-activityType>
                        <p-inputgroup>
                          <p-inputgroup-addon>
                            <i class="pi pi-search"></i>
                          </p-inputgroup-addon>
                          <input
                            #activityTypeInput
                            type="text"
                            pInputText
                            placeholder="Filter"
                            (keyup)="filterActivityTypes($event, i)"
                            value="{{ ActivityTypefilterValue[i] }}"
                          />                  
                        </p-inputgroup>
                      </ng-template>
                    </p-dropdown>
                    <label for="activityType"
                      >Activity Type<span class="requiredLable">*</span></label
                    >
                  </p-iftalabel>
                </p-inputgroup>
              </div>

              <!-- Claim Percent % -->
              <div class="field col-12 md:col-3">
                <p-inputgroup>
                  <p-inputgroup-addon>
                    <i class="pi pi-percentage"></i>
                  </p-inputgroup-addon>
                  <p-iftalabel>
                    <input
                      type="number"
                      pInputText
                      formControlName="claimPercent"
                      id="claimPercent"
                      min="0"
                      class="w-full"
                      placeholder="Enter Claim Percent %"
                      [ngClass]="{
                        'p-invalid': isDetailsInvalid(i, 'claimPercent')
                      }"
                      (input)="validatePercentage($event, 'claimPercent', i)"
                    />
                    <label for="claimPercent"
                      >Claim Percent %<span class="requiredLable"
                        >*</span
                      ></label
                    >
                  </p-iftalabel>
                </p-inputgroup>
              </div>

              <!-- start date required -->
              <div class="field col-12 md:col-3">
                <p-inputgroup>
                  <p-inputgroup-addon
                    ><i class="pi pi-calendar"></i
                  ></p-inputgroup-addon>
                  <p-iftalabel>
                    <p-datePicker
                      formControlName="startDate"
                      [showIcon]="true"
                      inputId="startDate"
                      class="w-full"
                      [appendTo]="'body'"
                      [style]="{ width: '100%' }"
                      [minDate]="tomorrowDate"
                      [inputStyleClass]="
                        isDetailsInvalid(i, 'startDate') ? 'p-invalid' : ''
                      "
                    ></p-datePicker>
                    <label for="startDate"
                      >Start Date<span class="requiredLable">*</span></label
                    >
                  </p-iftalabel>
                </p-inputgroup>
              </div>

              <!-- end date requird -->
              <div class="field col-12 md:col-3">
                <p-inputgroup>
                  <p-inputgroup-addon
                    ><i class="pi pi-calendar"></i
                  ></p-inputgroup-addon>
                  <p-iftalabel>
                    <p-datePicker
                      formControlName="endDate"
                      [showIcon]="true"
                      inputId="endDate"
                      class="w-full"
                      [appendTo]="'body'"
                      [style]="{ width: '100%' }"
                      [minDate]="claimContractDetails.get('startDate')?.value"
                    ></p-datePicker>
                    <label for="endDate">End Date</label>
                  </p-iftalabel>
                  <p-inputgroup-addon>
                    <p-button
                      type="button"
                      icon="pi pi-times"
                      (click)="claimContractDetails.at(i).get('endDate')?.reset()"
                      styleClass="p-button-secondary addOnBtnClear"
                      aria-label="Clear End Date"
                    ></p-button>
                  </p-inputgroup-addon>
                </p-inputgroup>
              </div>
              <div class="field col-12 md:col-2">
                <p-inputgroup>
                  <p-inputgroup-addon>
                    <i class="pi pi-building"></i>
                  </p-inputgroup-addon>
                  <p-iftalabel>
                    <p-dropdown
                      [fluid]="true"
                      [options]="discountTypes"
                      formControlName="discountType"
                      optionLabel="label"
                      optionValue="value"
                      inputId="discountType"
                      class="w-full"
                      placeholder="Select Discount Type"
                      [ngClass]="{
                        'p-invalid': isDetailsInvalid(i, 'discountType')
                      }"
                    ></p-dropdown>
                    <label for="discountType"
                      >Discount Type<span class="requiredLable">*</span></label
                    >
                  </p-iftalabel>
                </p-inputgroup>
              </div>
              <div class="p-col-1 md:col-1  align-items-end"></div> 
              <div class="p-col-2 md:col-2  align-items-end">
                <button
                  pButton
                  label="AP GL Segments"
                  icon="pi pi-pencil"               
                  (click)="openRowModal(i)"
                ></button>
           
                <button
                  pButton
                  icon="pi pi-trash"
                  class="p-button-danger"
                  *ngIf="i > 0"
                  (click)="removeItemFromClaimContractDetail(i)"
                ></button>
              </div>

              <div class="col-12">
                <hr
                  class="my-3 mx-0 border-top-1 border-bottom-none border-300"
                />
              </div>
            </div>
          </div>

          <div class="p-field p-col-2 flex align-items-end">
            <button
              pButton
              label="Add Item"
              icon="pi pi-plus"
              (click)="addItemToClaimContractDetail()"
            ></button>
          </div>
        </div>
      </div>

      <!-- <div class="mt-4">
            <p-fieldset legend="Attachments" [toggleable]="true">
                <p-fileUpload 
                    name="attachments[]" 
                    (onSelect)="onFileSelect($event)" 
                    [multiple]="true" 
                    [accept]="attachmentAcceptTypes"
                    [maxFileSize]="maxFileSize"
                    [showUploadButton]="false" 
                    [showCancelButton]="false"
                    chooseLabel="Choose Files">
                </p-fileUpload>
                
                <div class="mt-4 grid" *ngIf="attachments.controls.length > 0">
                    <div *ngFor="let control of attachments.controls; let i = index" class="col-12 md:col-6 lg:col-4">
                        <div class="flex align-items-center justify-content-between p-2 border-1 surface-border border-round">
                            <span class="font-medium text-sm white-space-nowrap overflow-hidden text-overflow-ellipsis"><i class="pi pi-file mr-2"></i>{{ control.get('fileName')?.value }}</span>
                            <p-button icon="pi pi-times" styleClass="p-button-danger p-button-text p-button-rounded" (click)="removeAttachment(i)"></p-button>
                        </div>
                    </div>
                </div>
            </p-fieldset>
        </div> -->

      <div class="flex justify-content-end gap-2 m-4 mt-6">
        <p-button
          label="Cancel"
          icon="pi pi-times"
          styleClass="p-button-secondary"
          (click)="onCancel()"
        ></p-button>
        <p-button
          label="Save"
          icon="pi pi-check"
          (click)="submitForm()"
          [loading]="isLoading"
        ></p-button>
      </div>
    </form>
  </div>

  <!-- Modal for per-row required fields -->
  <p-dialog
    header="Ap GL Segments"
    [(visible)]="showRowModal"
    [modal]="true"
    [dismissableMask]="true"
    [style]="{ width: '920px' }"
  >
    <form *ngIf="rowModalForm" [formGroup]="rowModalForm" autocomplete="off">
      <div class="grid formgrid p-fluid">
        <div class="field col-2">
          <p-iftalabel>
            <input
              pInputText
              formControlName="apGlSegment1"
              class="w-full"
              [ngClass]="{'p-invalid': isRowModalFieldInvalid('apGlSegment1')}"
              placeholder="GL Segment 1"
            />
            <label>GL Segment 1<span class="requiredLable">*</span></label>
          </p-iftalabel>
        </div>
        <div class="field col-2">
          <p-iftalabel>
            <input
              pInputText
              formControlName="apGlSegment2"
              class="w-full"
              [ngClass]="{'p-invalid': isRowModalFieldInvalid('apGlSegment2')}"
              placeholder="GL Segment 2"
            />
            <label>GL Segment 2<span class="requiredLable">*</span></label>
          </p-iftalabel>
        </div>
        <div class="field col-2">
          <p-iftalabel>
            <input
              pInputText
              formControlName="apGlSegment3"
              class="w-full"
              [ngClass]="{'p-invalid': isRowModalFieldInvalid('apGlSegment3')}"
              placeholder="GL Segment 3"
            />
            <label>GL Segment 3<span class="requiredLable">*</span></label>
          </p-iftalabel>
        </div>
        <div class="field col-2">
          <p-iftalabel>
            <input
              pInputText
              formControlName="apGlSegment4"
              class="w-full"
              [ngClass]="{'p-invalid': isRowModalFieldInvalid('apGlSegment4')}"
              placeholder="GL Segment 4"
            />
            <label>GL Segment 4<span class="requiredLable">*</span></label>
          </p-iftalabel>
        </div>
        <div class="field col-2">
          <p-iftalabel>
            <input
              pInputText
              formControlName="apGlSegment5"
              class="w-full"
              [ngClass]="{'p-invalid': isRowModalFieldInvalid('apGlSegment5')}"
              placeholder="GL Segment 5"
            />
            <label>GL Segment 5<span class="requiredLable">*</span></label>
          </p-iftalabel>
        </div>
        <div class="field col-2">
          <p-iftalabel>
            <input
              pInputText
              formControlName="apGlSegment6"
              class="w-full"
              [ngClass]="{'p-invalid': isRowModalFieldInvalid('apGlSegment6')}"
              placeholder="GL Segment 6"
            />
            <label>GL Segment 6<span class="requiredLable">*</span></label>
          </p-iftalabel>
        </div>
        <div class="field col-2">
          <p-iftalabel>
            <input
              pInputText
              formControlName="apGlSegment7"
              class="w-full"
              [ngClass]="{'p-invalid': isRowModalFieldInvalid('apGlSegment7')}"
              placeholder="GL Segment 7"
            />
            <label>GL Segment 7<span class="requiredLable">*</span></label>
          </p-iftalabel>
        </div>
        <div class="field col-2">
          <p-iftalabel>
            <input
              pInputText
              formControlName="apGlSegment8"
              class="w-full"
              [ngClass]="{'p-invalid': isRowModalFieldInvalid('apGlSegment8')}"
              placeholder="GL Segment 8"
            />
            <label>GL Segment 8<span class="requiredLable">*</span></label>
          </p-iftalabel>
        </div>
        <div class="field col-2">
          <p-iftalabel>
            <input
              pInputText
              formControlName="apGlSegment9"
              class="w-full"
              [ngClass]="{'p-invalid': isRowModalFieldInvalid('apGlSegment9')}"
              placeholder="GL Segment 9"
            />
            <label>GL Segment 9<span class="requiredLable">*</span></label>
          </p-iftalabel>
        </div>
        <div class="field col-2">
          <p-iftalabel>
            <input
              pInputText
              formControlName="apGlSegment10"
              class="w-full"
              [ngClass]="{'p-invalid': isRowModalFieldInvalid('apGlSegment10')}"
              placeholder="GL Segment 10"
            
            />
            <label>GL Segment 10<span class="requiredLable">*</span></label>
          </p-iftalabel>
        </div>
      </div>

      <div class="p-dialog-footer">
        <button pButton type="button" label="Confirm" (click)="confirmRowModal()"></button>
        <button
          pButton
          label="Cancel"
          class="p-button-text"
          (click)="closeRowModal()"
        ></button>
      </div>
    </form>
  </p-dialog>
</div>
